import { getCampaignStateForTransition } from 'modules/campaigns/editor/utils';
import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { ModalType, useCampaignContext, useModalContext } from '../../context';
import { BoldText } from '../../styles';
import { useChangeCampaignState } from './useChangeCampaignState';

export const CHANGE_CAMPAIGN_STATE_MODAL_TEST_ID = 'change-campaign-state-modal';
export const CHANGE_CAMPAIGN_STATE_BUTTON_TEST_ID = 'change-campaign-state-button';

export const ChangeCampaignStateModal = () => {
  const { closeModal } = useModalContext();
  const { isLoading, changeCampaignState } = useChangeCampaignState();
  const {
    campaign: { name, campaignState: currentState },
  } = useCampaignContext();
  const campaignState = getCampaignStateForTransition(currentState);

  const handleConfirm = () => {
    changeCampaignState(campaignState);
  };

  return (
    <Modal
      withPortal
      isModalOpen={true}
      onClose={() => closeModal(ModalType.ChangeCampaignState)}
      id="change-campaign-state-modal"
      data-test={CHANGE_CAMPAIGN_STATE_MODAL_TEST_ID}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>Change campaign state?</ModalHeader>
      <ModalBody>
        Are you sure you want to change <BoldText>{name}</BoldText> to{' '}
        <BoldText>{campaignState}</BoldText>?
      </ModalBody>
      <ModalFooter>
        <DestructiveButton
          data-test={CHANGE_CAMPAIGN_STATE_BUTTON_TEST_ID}
          onClick={handleConfirm}
          isLoading={isLoading}
          size={BUTTON_SIZES.LARGE}
        >
          Force state change
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
